/* eslint-disable import/no-duplicates */
import React from "react"
import Grid from "../../../../../../../components/Habitacional/core/Grid"
import FinancingContractInput from "../../../../../../../components/Habitacional/core/Form/InputCompleteDocuments/FinancingContractInput"
import RetirementLetterInput from "../../../../../../../components/Habitacional/core/Form/InputCompleteDocuments/RetirementLetterInput"
import PublicationOfRetirementInput from "../../../../../../../components/Habitacional/core/Form/InputCompleteDocuments/PublicationOfRetirementInput"
import MedicalReportsInput from "../../../../../../../components/Habitacional/core/Form/InputCompleteDocuments/MedicalReportsInput"
import DPSInput from "../../../../../../../components/Habitacional/core/Form/InputCompleteDocuments/DPSInput"

const IncapacityByDisease = ({ updateSendStatus }) => {

    return (
        <>
            <Grid item md={6} lg={6} xl={6}>
                <FinancingContractInput updateSendStatus={updateSendStatus} />
            </Grid>
            <Grid item md={6} lg={6} xl={6}>
                <RetirementLetterInput updateSendStatus={updateSendStatus} />
            </Grid>
            <Grid item md={6} lg={6} xl={6}>
                <PublicationOfRetirementInput updateSendStatus={updateSendStatus} />
            </Grid>
            <Grid item md={6} lg={6} xl={6}>
                <MedicalReportsInput updateSendStatus={updateSendStatus} />
            </Grid>
            <Grid item md={6} lg={6} xl={6}>
                <DPSInput updateSendStatus={updateSendStatus} />
            </Grid>
        </>
    )
}

export default IncapacityByDisease